import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface DPEStats {
  new: number;
  noOwner: number;
  identified: number;
  inProcess: number;
  processed: number;
  voluntarilyUntreated: number;
  total: number;
}

export interface OwnerStats {
  notContacted: number;
  waitingForFeedback: number;
  toRecall: number;
  toCall: number;
  refused: number;
  unableToReach: number;
  total: number;
}

export interface RoleStats {
  toContact: number;
  waitingForMeeting: number;
  refused: number;
  closed: number;
  total: number;
  meetingsToday: number;
  meetingsTomorrow: number;
  meetingsLate: number;
}

export interface UrgentActions {
  late: number;
  today: number;
  tomorrow: number;
  meetingsToday: number;
  meetingsTomorrow: number;
}

export interface CRMStats {
  dpe: DPEStats;
  owners: OwnerStats;
  transaction: RoleStats;
  gestionLocative: RoleStats;
  urgentActions: UrgentActions;
}

export interface VigilanceStats {
  nbCoprosNew: number;
  nbCoprosLost: number;
  crm?: CRMStats;
}

export interface ModuleState {
  vigilanceStats: VigilanceStats | null;
}

const initialState: ModuleState = {
  vigilanceStats: null,
};

const moduleSlice = createSlice({
  name: 'module',
  initialState,
  reducers: {
    setVigilanceStats: (state, action: PayloadAction<VigilanceStats>) => {
      state.vigilanceStats = action.payload;
    },
  },
});

export const { setVigilanceStats } = moduleSlice.actions;
export default moduleSlice.reducer;
